import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { ClockUtcComponent } from '@layout/clock-utc/clock-utc.component';
import { MenuProfileComponent } from '@layout/menu-profile/menu-profile.component';
import { MenuServicesComponent } from '@layout/menu-services/menu-services.component';
import { MenuSupportComponent } from '@layout/menu-support/menu-support.component';
import { UserAvatarComponent } from '@layout/user-avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormatterHelper } from '@shared/helpers';
import { CurrentUserService, LayoutService } from '@shared/services';
import { AppRoutesEnum, CurrentUser } from '@shared/types';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        MenuServicesComponent,
        MenuSupportComponent,
        MenuProfileComponent,
        UserAvatarComponent,
        PopoverModule,
        ButtonModule,
        ClockUtcComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
    private currentUserService = inject(CurrentUserService);
    private layoutService = inject(LayoutService);

    currentUser = signal<CurrentUser | null>(this.currentUserService.currentUser());
    userShortName = signal<string | null>(
        FormatterHelper.computeUserShortName(this.currentUser()?.firstName ?? '', this.currentUser()?.lastName ?? '')
    );
    isSidebarCollapsed = signal<boolean>(this.layoutService.isSidebarCollapsed$.value);

    menuProfileOpened = signal<boolean>(false);
    menuSupportOpened = signal<boolean>(false);
    menuServicesOpened = signal<boolean>(false);

    protected readonly urls = AppRoutesEnum;
    protected readonly colonyNotificationsUrl = environment.colonyNotificationsUrl;
    protected readonly colonyOrdersCartUrl = environment.colonyOrdersCartUrl;

    constructor() {
        this.layoutService.isSidebarCollapsed$.subscribe(isCollapsed => {
            this.isSidebarCollapsed.set(isCollapsed);
        });
    }
}
